module.exports = __webpack_public_path__ + "static/media/background.7ecd1c07.png";